import { HttpClient } from "../HttpClient";

export const GetClaimSubmissionList = async (params = {}) => {
  try {
    const { data } = await HttpClient.get(`api/ClipSubmissions`, { params });
    return data;
  } catch (err) {
    return null;
  }
};
